export default __webpack_public_path__ + "static/media/f_facebook.28ca5b30.svg";